var map = {
	"./1Wohnzimmer.jpg": 264,
	"./1Wohnzimmer2.jpg": 72,
	"./2Esszimmer.jpg": 404,
	"./3Kueche2.jpg": 813,
	"./4Gemsstockzimmer 2.jpg": 457,
	"./4Gemsstockzimmer1.jpg": 702,
	"./5Naetschenzimmer.jpg": 341,
	"./6Kajuetenzimmer.jpg": 846,
	"./7Balkon.jpg": 245,
	"./8WC.jpg": 719,
	"./90bad.jpg": 541,
	"./91aussen.jpeg": 487,
	"./92floorplan.jpg": 149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 725;